var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('main', {
    class: [{
      loaded: _vm.loaded
    }]
  }, [_c('loading-overlay', {
    attrs: {
      "wait-for": _vm.redirecting,
      "tracking": {
        class: 'prequal',
        subclass: 'page'
      }
    },
    model: {
      value: _vm.loaded,
      callback: function ($$v) {
        _vm.loaded = $$v;
      },
      expression: "loaded"
    }
  }), _vm._v(" "), _c('page-header', {
    attrs: {
      "fixed": true,
      "backdrop": false,
      "show-apply-now": false,
      "show-login-link": true,
      "login-query": _vm.headerLoginQuery
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade",
      "mode": "out-in"
    }
  }, [_c('section', {
    key: 'phone',
    staticClass: "section--phone"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('progress-indicator', {
    staticClass: "sm-md:mt-4 mb-4",
    attrs: {
      "step": 1
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "container max-w-lg section--content",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('h1', {
    staticClass: "mt-4 tracking-normal"
  }, [_vm._v("Nice to meet you.")]), _vm._v(" "), _c('div', {
    staticClass: "flex space-x-5"
  }, [_c('div', {
    staticClass: "flex-grow"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.first_name,
      expression: "first_name"
    }],
    staticClass: "block mt-10 text-left sm-md:mt-4",
    class: [_vm.showFormError.first_name && 'invalid_border', _vm.shakeForm.first_name && 'invalid'],
    attrs: {
      "autocomplete": "given-name",
      "name": "first_name",
      "placeholder": "First name"
    },
    domProps: {
      "value": _vm.first_name
    },
    on: {
      "focus": () => _vm.onFieldFocus('first_name'),
      "blur": () => _vm.onFieldBlur('first_name'),
      "keyup": () => _vm.onFieldChange('first_name'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.first_name = $event.target.value;
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-grow"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.last_name,
      expression: "last_name"
    }],
    staticClass: "block mt-10 text-left sm-md:mt-4",
    class: [_vm.showFormError.last_name && 'invalid_border', _vm.shakeForm.last_name && 'invalid'],
    attrs: {
      "autocomplete": "family-name",
      "name": "last_name",
      "placeholder": "Last name"
    },
    domProps: {
      "value": _vm.last_name
    },
    on: {
      "focus": () => _vm.onFieldFocus('last_name'),
      "blur": () => _vm.onFieldBlur('last_name'),
      "keyup": () => _vm.onFieldChange('last_name'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.last_name = $event.target.value;
      }
    }
  })])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.phone,
      expression: "phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ['###-###-####', '+##-##########'],
      expression: "['###-###-####', '+##-##########']"
    }],
    staticClass: "block mt-10 text-left sm-md:mt-4",
    class: [_vm.showFormError.phone && 'invalid_border', _vm.shakeForm.phone && 'invalid'],
    attrs: {
      "type": "tel",
      "autocomplete": "tel-national",
      "name": "phone",
      "placeholder": "Mobile number"
    },
    domProps: {
      "value": _vm.phone
    },
    on: {
      "focus": () => _vm.onFieldFocus('phone'),
      "blur": () => _vm.onFieldBlur('phone'),
      "keyup": () => _vm.onFieldChange('phone'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.phone = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.email,
      expression: "email"
    }],
    staticClass: "block mt-10 text-left sm-md:mt-4",
    class: [_vm.showFormError.email && 'invalid_border', _vm.shakeForm.email && 'invalid'],
    attrs: {
      "type": "email",
      "autocomplete": "email",
      "name": "email",
      "placeholder": "Email address"
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "focus": () => _vm.onFieldFocus('email'),
      "blur": () => _vm.onFieldBlur('email'),
      "keyup": () => _vm.onFieldChange('email'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.email = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.date_of_birth,
      expression: "date_of_birth"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: '##/##/####',
      expression: "'##/##/####'"
    }],
    staticClass: "block mt-10 text-left sm-md:mt-4",
    class: [_vm.showFormError.date_of_birth && 'invalid_border', _vm.shakeForm.date_of_birth && 'invalid', _vm.isUnder18 && 'is-under-18'],
    attrs: {
      "id": "application-date_of_birth",
      "type": "text",
      "pattern": "\\d{2}/\\d{2}/\\d{4}",
      "autocomplete": "bday",
      "name": "date_of_birth",
      "placeholder": "Date of birth (MM/DD/YYYY)"
    },
    domProps: {
      "value": _vm.date_of_birth
    },
    on: {
      "focus": () => _vm.onFieldFocus('date_of_birth'),
      "blur": () => _vm.onFieldBlur('date_of_birth'),
      "keyup": () => _vm.onFieldChange('date_of_birth'),
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.date_of_birth = $event.target.value;
      }
    }
  }), _vm._v(" "), _vm.isUnder18 ? _c('label', {
    staticClass: "block leading-6 text-xs text-red-400",
    attrs: {
      "for": "application-date_of_birth"
    }
  }, [_vm._v("You must be 18 years or older to apply.")]) : _vm._e(), _vm._v(" "), _vm.showError ? _c('div', {
    staticClass: "text-red-400 text-base"
  }, _vm._l(_vm.errorMsgs, function (msg, index) {
    return _c('p', {
      key: index,
      class: [index && 'mt-2'],
      attrs: {
        "value": msg
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(msg) + "\n\t\t\t\t\t\t")]);
  }), 0) : _vm._e(), _vm._v(" "), _c('prequal-disclaimers', {
    on: {
      "showDisclosure": _vm.showThisDisclosure
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-10 px-16 sm:w-full",
    class: {
      disabled: _vm.processing || !_vm.readyToSubmit
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.processing
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.processing ? 'Checking...' : 'Continue') + "\n\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "mt-8 leading-6 text-disclosure"
  }, [_vm._v("\n\t\t\t\t\t\tIMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT — To help the\n\t\t\t\t\t\tgovernment fight the funding of terrorism and money laundering activities, federal law\n\t\t\t\t\t\trequires all financial institutions and their third parties to obtain, verify, and\n\t\t\t\t\t\trecord information that identifies each person who opens an account. What this means\n\t\t\t\t\t\tfor you: When you open an account, we will ask for your name, address, date of birth,\n\t\t\t\t\t\tand other information that will allow us to identify you. We may also ask to see your\n\t\t\t\t\t\tdriver's license or other identifying documents.\n\t\t\t\t\t")])], 1)], 1)])]), _vm._v(" "), _c('disclosure-modal', {
    attrs: {
      "show": _vm.showDisclosure,
      "disclosure": _vm.disclosureFile
    },
    on: {
      "close": _vm.viewedDisclosure
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };